<template>
  <div id="SentimentCat">
    <!-- <Breadcrumb :list="list"/> -->
    <div data-html2canvas-ignore="true" v-show="loader">
      <Loader />
    </div>
    <div class="card datepickerwrap" style="text-align: left; margin-right: 8px">
      <div class="wrapitem">
        <div style="width: 60%">
          <datecomponent ref="datecomponent"></datecomponent>
          <div class="datebox">
            <button @click="refresh" class="btn primarycolor" type="button">
              Submit
            </button>
          </div>
        </div>
        <div class="datebox ml-2">
          <button class="btn btn-block primarycolor" @click="createPdf">Download</button>
        </div>
        <div class="datebox">
          <button style="padding-left: 0; padding-right: 0" class="btn btn-block primarycolor" @click="downloadExcel">
            Download Review
          </button>
        </div>
        <div class="datebox">
          <p class="channel-title">Channel:</p>
          <select @change="processCategory" v-model="channelSelector" class="form-control text-uppercase customSelect">
            <option :value="website.platform_name" v-for="website of viewPlatformAndCategoryData.platform"
              :key="website.platform_name">
              {{ website.platform_name }}
            </option>
          </select>
        </div>
        <div class="datebox">
          <select @change="icChanged" v-model="selectedItemCategory" class="form-control text-uppercase customSelect">
            <option v-for="d in itemCategory" :value="d" :key="d.key">
              {{ d.value }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div id="sentimentPdf">
      <div class="d-flex datepickerwrap">
        <div class="separated-card w-100" :key="idx" v-for="(ud, idx) in products">
          <select @change="changeProduct(ud, idx)" v-model="selectedProducts[idx]"
            class="form-control customSelect text-uppercase" style="margin-bottom: -10px">
            <optgroup label="Primary">
              <option v-for="d in primaryProductsOptions" :value="d.product_name">
                {{ d.product_name.toUpperCase() }}
              </option>
            </optgroup>
            <optgroup label="Competitor">
              <option v-for="d in nonPrimaryProductsOptions" :value="d.product_name">
                {{ d.product_name.toUpperCase() }}
              </option>
            </optgroup>
          </select>
        </div>
      </div>
      <div class="datepickerwrap">
        <div>
          <h5 class="positive-head">Positive</h5>
          <div class="datepickerwrap d-flex ml-0 mr-0 pr-0" style="margin-top: -5px !important">
            <div class="card separated-card w-100" :key="idx" v-for="(ud, idx) in products">
              <div data-html2canvas-ignore="true" style="margin: 0 1px 6px 1px"></div>
              <div v-if="defaultWords[ud.product_name] && renderCloud">
                <!-- <h5 class="cust-head">{{ ud.product_name.toUpperCase() }}</h5> -->
                <!-- {{ defaultWords[d.product_name] }} -->
                <div v-if="defaultWords[ud.product_name].positive.series[0].data.length">
                  <highcharts :options="defaultWords[ud.product_name].positive"></highcharts>
                </div>
                <div class="text-danger" v-else>No Data!</div>
              </div>
            </div>
          </div>
          <h5 class="negative-head" style="margin-top: -20px !important">Negative</h5>
          <div class="datepickerwrap d-flex ml-0 mr-0 pr-0" style="margin-top: -5px !important">
            <div class="card separated-card w-100" :key="idx" v-for="(ud, idx) in products">
              <div v-if="defaultWords[ud.product_name] && renderCloud">
                <!-- <h5 style="color: var(--primary_brand); font-weight: 400; margin-bottom: 18px;">{{
                  ud.produFposct_name.toUpperCase()
                }}</h5> -->
                <div  v-if="defaultWords[ud.product_name].negative.series[0].data.length">
                  <highcharts :options="defaultWords[ud.product_name].negative"></highcharts>
                </div>
                <div class="text-danger" v-else>No Data!</div>
              </div>
            </div>
          </div>
          <h5 class="positive-head" style="margin-top: -20px !important">All</h5>
          <div class="datepickerwrap d-flex ml-0 mr-0 pr-0" style="margin-top: -5px !important">
            <div class="card separated-card w-100 h-100" :key="idx" v-for="(ud, idx) in products">
              <div>
                <!-- <h5 style="color: var(--primary_brand); font-weight: 400; margin-bottom: 18px;">{{
                  ud.product_name.toUpperCase()
                }}</h5> -->
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Keyword</th>
                      <th scope="col">Frequency</th>
                      <th scope="col">Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="d in tableData[ud.product_name]" v-if="tableData[ud.product_name].length">
                      <td>
                        <span style="color: #20a8d8; cursor: pointer" @click="openModal(d.word, ud.product_name, '')">{{
        d.word }}</span>
                      </td>
                      <td>
                        <div style="color: var(--green); margin-bottom: 8px">
                          {{ d.positive_frequency | format }}
                        </div>
                        <div style="color: var(--red)">
                          {{ d.negative_frequency | format }}
                        </div>
                      </td>
                      <td>
                        <div v-if="renderChart">
                          <div v-if="charts[ud.product_name][d.word]">
                            <highcharts style="
                                width: fit-content;
                                height: 89px;
                                margin: auto;
                                margin-top: 7px;
                              " :options="charts[ud.product_name][d.word]"></highcharts>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="xl" :title="modalTitle" v-model="showModal">
      <div v-show="modalLoader">
        <Loader />
      </div>
      <div class="leftcontent wrapitem">
        <datecomponent ref="modaldatecomponent" :noSaveProp="true"></datecomponent>
        <div class="datebox" style="margin-left: -100px">
          <button @click="refreshModal('modaldatecomponent')" class="btn primarycolor" type="button">
            Submit
          </button>
        </div>
      </div>
      <div class="card" style="margin-top: 10px">
        <div style="">
          <h4 style="
              display: inline-block;
              padding-top: 10px;
              text-transform: capitalize;
              font-family: 'Poppins', sans-serif;
              color: var(--primary_brand);
            ">
            {{ chartDataKey.split("_").join(" ") }}
          </h4>
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
            <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons button-variant="outline-secondary"
              @change="getKeywordChartData" v-model="interval" name="radiosBtn">
              <b-form-radio class="mx-0" value="month">Month</b-form-radio>
              <b-form-radio class="mx-0" value="week">Week</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
          <span class="float-right" style="margin-right: 10px">
            <select class="form-control customSelect" @change="processChartData" v-model="chartDataKey">
              <option value="frequency">Frequency</option>
              <option value="score">Score</option>
              <option value="reviews_count">Review Count</option>
            </select>
          </span>
        </div>
        <highcharts :options="modalChart" v-if="activeModalChart" style="margin-top: 10px"></highcharts>
        <div v-if="!activeModalChart">No data</div>
      </div>
      <div class="borderBetween"></div>
      <div class="datebox" style="width: unset !important">
        <button :class="{ highlight_primary: modalSentimentType == '' }" @click="changeSentimentType('')"
          class="btn primarycolor" style="margin-right: 5px">
          All
        </button>
        <button :class="{ highlight_success: modalSentimentType == 'positive' }"
          @click="changeSentimentType('positive')" class="btn success" style="margin-right: 5px">
          Positive
        </button>
        <button :class="{ highlight_danger: modalSentimentType == 'negative' }" @click="changeSentimentType('negative')"
          class="btn danger" style="margin-right: 5px">
          Negative
        </button>
      </div>
      <div class="reviews-panel productScroll">
        <div v-for="d in modalData.data" class="each-review">
          <div class="usericon">
            <img src="Icons_SVG/User.svg" />
          </div>
          <div class="username">
            {{ d.person_name }}
          </div>
          <div class="usertimestamp">
            {{ d.review_date }}
          </div>
          <div class="helpful">
            Helpful: {{ d.found_helpful }}
            <a :href="d.review_link" target="_blank"> Link </a>
          </div>
          <div class="usertext">
            {{ d.review }}
          </div>
          <hr style="margin-block: 0.2rem !important" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CardLine1ChartExample from ".././dashboard/CardLine1ChartExample";
import CardLine2ChartExample from ".././dashboard/CardLine2ChartExample";
import CardLine3ChartExample from "../dashboard/CardLine3ChartExample";
import CardBarChartExample from ".././dashboard/CardBarChartExample";
import MainChartExample from ".././dashboard/MainChartExample";
import SocialBoxChartExample from ".././dashboard/SocialBoxChartExample";
import CalloutChartExample from ".././dashboard/CalloutChartExample";
import { Callout } from "@coreui/vue";
import moment from "moment";
import datecomponent from "./DateMotherCare.vue";
import Loader from "../Components/Loader.vue";
export default {
  name: "Sentiment",
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    datecomponent,
    Loader
  },

  data: function () {
    return {
      showModal: false,
      renderChart: false,
      selected: "",
      modalLoader: false,
      keywordChartData: {},
      modalTitle: "",
      modalProductName: "",
      renderCloud: false,
      modalSentimentType: "",
      tableData: {},
      modalData: {},
      modalChart: {},
      chartDataKey: "frequency",
      interval: "month",
      activeModalChart: false,
      data: [],
      loader: true,
      userData: JSON.parse(localStorage.getItem("reviewUserData")),
      customData: JSON.parse(localStorage.getItem("reviewCustomData")),
      products: [],
      nonPrimaryProductsOptions: [],
      primaryProductsOptions: [],
      selectedProducts: [],
      channelSelector: "amazon",
      brand: "",
      charts: {},
      date: {
        startDate: "2017-01-01",
        endDate: moment().format("YYYY-MM-DD"),
      },
      myColors: [
        "darkgreen",
        "lightgreen",
        "mediumseagreen",
        "lightseagreen",
        "darkblue",
        "blue",
        "lightskyblue",
        "yellow",
        "orange",
        "red",
      ],
      defaultWords: {},
      itemCategory: [],
      selectedItemCategory: {},
      productList: {},
      competitorData: {},
      customClient: JSON.parse(localStorage.reviewUserData).data.client,
      viewPlatformAndCategoryData: JSON.parse(localStorage.viewPlatformAndCategoryData),
    };
  },

  mounted() {
    if (localStorage.demo_voc_channelSelector)
      this.channelSelector = localStorage.demo_voc_channelSelector;
    else
      this.channelSelector = this.viewPlatformAndCategoryData.platform[0].platform_name;
    this.processCategory();
    this.getCompetitorSet();
  },
  methods: {
    getCompetitorSet() {
      let self = this;
      let url = "/api/india_clinets/product_set_list_compare";
      let payload = {
        client: self.customClient,
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.competitorData = response.body.data.voc_product_list;
        },
        (err) => {
        }
      );
    },
    processCategory() {
      localStorage.demo_voc_channelSelector = this.channelSelector;
      this.itemCategory = [];
      if (localStorage.demo_voc_product_list)
        this.productList = JSON.parse(localStorage.demo_voc_product_list);
      for (let [i, k] of Object.keys(this.productList[this.channelSelector]).entries()) {
        this.itemCategory.push({ key: k, value: k.replace("_", " ") });
      }
      if (localStorage.demo_selectedItemCategory) {
        this.selectedItemCategory = {};
        for (let [i, k] of this.itemCategory.entries()) {
          if (k.key == JSON.parse(localStorage.demo_selectedItemCategory).key) {
            this.selectedItemCategory = k;
          }
        }
        if (!Object.keys(this.selectedItemCategory).length) {
          this.selectedItemCategory = this.itemCategory[0];
        }
      } else this.selectedItemCategory = this.itemCategory[0];
      this.init();
    },
    icChanged() {
      localStorage.demo_selectedItemCategory = JSON.stringify(this.selectedItemCategory);
      this.init();
    },
    init() {
      this.nonPrimaryProductsOptions = [];
      this.primaryProductsOptions = [];
      this.products = [];
      this.selectedProducts = [];
      let color = ["#0072ba", "#f56628", "#f3b821"];
      let ci = 0;
      for (let [i, k] of this.productList[this.channelSelector][
        this.selectedItemCategory.key
      ].entries()) {
        let obj = {
          brand: "test",
          color: color[ci],
          forum: false,
          primary: k.primary,
          product_name: k.name,
        };
        if (k.primary) this.primaryProductsOptions.push(obj);
        else this.nonPrimaryProductsOptions.push(obj);
        if (ci == color.length - 1) ci = 0;
        else ci++;
      }
      this.products = [
        this.primaryProductsOptions[0],
        this.nonPrimaryProductsOptions[0],
        this.nonPrimaryProductsOptions[1],
      ];
      this.selectedProducts = [
        this.primaryProductsOptions[0].product_name,
        this.nonPrimaryProductsOptions[0].product_name,
        this.nonPrimaryProductsOptions[1].product_name,
      ];
      this.refresh();
    },

    refresh() {
      this.date = this.$refs.datecomponent.date;
      this.getData();
    },
    downloadExcel() {
      let self = this;
      this.loader = true;
      let url = "/api/reviews/reviewdownload";
      let payload = {
        start_date: this.date.startDate,
        end_date: this.date.endDate,
        product_list: this.selectedProducts,
      };
      this.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
        }
      );
    },
    createPdf() {
      let self = this;
      self.loader = true;
      let content = document.querySelector("#sentimentPdf");
      let canvasWidth = content.scrollWidth + 5;
      let canvasHeight = content.scrollHeight + 5;
      let options = {
        scale: 1.5,
        width: canvasWidth,
        onclone: function () {
          alert("Pdf generated. Download Now");
        },
      };
      setTimeout(function () {
        html2canvas(content, options).then((canvas) => {
          let imgData = canvas.toDataURL("image/jpeg", 1.0);
          let doc = new jsPDF("p", "mm", [canvasWidth, canvasHeight]);
          let pdfWidth = canvasWidth - 16;
          let pdfHeight = canvasHeight;
          doc.addImage(imgData, "JPEG", 8, 8, pdfWidth, pdfHeight);
          doc.save("voc_weavr_sentiment_" + moment().format("DDMMMYYYY") + ".pdf");
          self.loader = false;
        });
      }, 0);
    },
    changeProduct(ud, idx) {
      let self = this;
      if (idx == 0) {
        let isPrimary = false;
        let compData =
          self.competitorData[this.channelSelector][this.selectedItemCategory.key][
          self.selectedProducts[0]
          ];
        for (let [ci, cdata] of this.productList[this.channelSelector][
          this.selectedItemCategory.key
        ].entries()) {
          if (self.selectedProducts[0] == cdata.name) {
            if (cdata.primary) isPrimary = true;
          }
        }
        if (isPrimary) {
          self.selectedProducts[1] = compData.comp1;
          self.selectedProducts[2] = compData.comp2;
        }
      }
      self.products = [];
      let color = ["#0072ba", "#f56628", "#f3b821"];
      let cci = 0;
      for (let [pi, pdata] of this.selectedProducts.entries()) {
        for (let [ci, cdata] of this.productList[this.channelSelector][
          this.selectedItemCategory.key
        ].entries()) {
          if (pdata == cdata.name) {
            let obj = {
              brand: "test",
              color: color[cci],
              forum: false,
              primary: cdata.primary,
              product_name: cdata.name,
            };
            self.products.push(obj);
            if (cci == color.length - 1) cci = 0;
            else cci++;
          }
        }
      }
      self.refresh();
    },
    getKeywordChartData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      self.$nextTick(function () {
        self.keywordChartData = {};
        let url = "/api/reviews/keywisesentdata?interval=" + self.interval;
        url += "&keyword=" + self.modalTitle;
        url += "&product_name=" + self.modalProductName;
        if (self.channelSelector) url += "&channel=" + self.channelSelector;
        if (self.modalSentimentType) url += "&sentiment_type=" + self.modalSentimentType;
        if (this.date.startDate)
          url += "&start_date=" + this.date.startDate + "&end_date=" + this.date.endDate;
        self.$http.get(url).then(
          (response) => {
            self.keywordChartData = response.body;
            self.modalLoader = false;
            self.loader = false;
            self.processChartData();
          },
          (err) => {
            self.modalLoader = false;
            self.loader = false;
          }
        );
      });
    },
    processChartData() {
      let category = [];
      let series = [];
      let datakeys = [
        { key: "positive", label: "Positive", color: "#1ACF85" },
        { key: "negative", label: "Negative", color: "#FF786B" },
      ];
      for (let [i, k] of datakeys.entries()) {
        if (this.keywordChartData.data[k.key]) {
          let obj = {};
          obj.name = k.label;
          obj.data = [];
          obj.color = k.color;
          for (let [idx, dataset] of this.keywordChartData.data[k.key].entries()) {
            category.push(moment(dataset.date).format("MMM DD, YY"));
            obj.data.push(dataset[this.chartDataKey]);
          }
          series.push(obj);
        }
      }
      this.plotChart({ series: series, category: category });
    },
    plotChart(d) {
      var self = this;
      if (d.category.length) self.activeModalChart = true;
      else self.activeModalChart = false;
      this.modalChart = {
        credits: {
          enabled: false,
        },
        chart: {
          height: 210,
        },
        exporting: {
          enabled: false,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },

        yAxis: {
          title: {
            text: "",
          },
        },
        xAxis: {
          categories: d.category,
          crosshair: true,
          crosshair: {
            // color: "rgba(166, 215, 238)",
            width: 70,
          },
        },
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' + this.points[i].series.color + '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip += " : <b> " + self.format(this.points[i].y) + "</b> <br/>";
            }
            return mytooltip;
          },
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
          shared: true,
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: 0,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 15,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              states: {
                hover: {
                  radiusPlus: 1.5,
                  lineWidthPlus: 1,
                },
              },
            },
          },
        },
        series: d.series,
      };
    },
    refreshModal(k) {
      this.date = this.$refs[k].date;
      this.getKeywordChartData();
      this.getKeywordWiseData();
    },
    getKeywordWiseData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      let url = "/api/reviews/keywordwise";
      url += "?keyword=" + self.modalTitle;
      url += "&product_name=" + self.modalProductName;
      if (self.channelSelector) url += "&channel=" + self.channelSelector;
      if (self.modalSentimentType) url += "&sentiment_type=" + self.modalSentimentType;
      if (this.date.startDate)
        url += "&start_date=" + this.date.startDate + "&end_date=" + this.date.endDate;
      self.$http.get(url).then(
        (response) => {
          self.modalData = response.body;
          self.modalLoader = false;
          self.loader = false;
          if (!self.showModal) self.showModal = true;
        },
        (err) => {
          self.modalLoader = false;
          self.loader = false;
        }
      );
    },

    changeSentimentType(d) {
      this.$nextTick(function () {
        this.modalSentimentType = d;
        this.getKeywordWiseData();
      });
    },

    openModal(keyword, productName, type) {
      this.modalTitle = keyword;
      this.modalProductName = productName;
      this.modalSentimentType = type;
      this.refreshModal("datecomponent");
    },

    drawgauge(isRender, dataPositive, dataNegative, productName, keyword) {
      let self = this;
      let series = [];
      let value1 = Number(dataPositive);
      let value2 = Number(dataNegative);
      if (value1 && value2) {
        let obj = {};
        obj.name = "Positive";
        obj.color = "#1ACF85";
        obj.y = value1;
        series.push(obj);
        let obj2 = {};
        obj2.name = "Negative";
        obj2.color = "#FF786B";
        obj2.y = value2;
        series.push(obj2);
      } else {
        if (!value1) {
          let obj = {};
          obj.name = "Negative";
          obj.color = "#FF786B";
          obj.y = value2;
          series.push(obj);
          let obj2 = {};
          obj2.name = "other";
          obj2.color = "#B3B2B9";
          obj2.y = 100 - value2;
          obj2.dataLabels = { enabled: false };
          series.push(obj2);
        }
        if (!value2) {
          let obj = {};
          obj.name = "Positive";
          obj.color = "#1ACF85";
          obj.y = value1;
          series.push(obj);
          let obj2 = {};
          obj2.name = "other";
          obj2.color = "#B3B2B9";
          obj2.y = 100 - value1;
          obj2.dataLabels = { enabled: false };
          series.push(obj2);
        }
      }
      self.charts[productName] = {};
      self.$nextTick(function () {
        self.charts[productName][keyword] = {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false,
            margin: [0, 0, 0, 0],
            padding: [0, 0, 0, 0],
            height: 110,
            width: 180,
          },
          title: {
            text: "",
          },
          credits: {
            enabled: false,
          },
          exporting: {
            enabled: false
          },
          accessibility: {
            point: {
              valueSuffix: "%",
            },
          },
          tooltip: {
            formatter() {
              if (this.point.name == "other") {
                return false;
              }
              var mytooltip = "";
              // console.log(this.point)
              mytooltip +=
                '<span style="color:' + this.point.color + '!important">\u25CF</span> ';
              mytooltip += this.point.name;
              mytooltip += " : <b> " + self.format(this.point.y) + "%</b> <br/>";
              return mytooltip;
            },
            borderWidth: 0,
            shadow: {
              color: "#d6d6d6",
              opacity: 0.1,
              width: 10,
            },
            borderRadius: 6,
            backgroundColor: "#ffffff",
          },
          plotOptions: {
            series: {
              borderWidth: 0,
            },
            pie: {
              dataLabels: {
                enabled: true,
                distance: -15,
                format: "{point.y:.1f}",
                style: {
                  fontSize: 11,
                },
              },
              showInLegend: true,
              startAngle: -90,
              endAngle: 90,
              size: "100%",
              center: ["50%", "57%"],
            },
          },
          legend: {
            enabled: false,
            itemStyle: {
              fontSize: 9,
              fontWeight: 1,
            },
          },
          series: [
            {
              type: "pie",
              innerSize: "59%",
              data: series,
            },
          ],
        };
        self.$nextTick(function () {
          if (isRender) {
            self.renderChart = true;
          }
        });
      });
    },
    format(v) {
      return this.$options.filters.format(v);
    },
    plotWordCloud(product_name, type, data, min, max, color) {
      this.defaultWords[product_name] = {};
      this.defaultWords[product_name][type] = {};
      this.$nextTick(function () {
        this.defaultWords[product_name][type] = {
          chart: {
            height: 180,
          },
          credits: {
            enabled: false,
          },
          exporting: {
            enabled: false
          },
          tooltip: {
            borderWidth: 0,
            shadow: {
              color: "#d6d6d6",
              opacity: 0.1,
              width: 10,
            },
            borderRadius: 6,
            backgroundColor: "#ffffff",
          },
          series: [
            {
              type: "wordcloud",
              data: data,
              name: "Frequency",
              rotation: {
                from: 0,
                to: 0,
                orientations: 1,
              },
              minFontSize: min,
              maxFontSize: max,
              colors: [color],
              style: { fontWeight: "400" },
            },
          ],
          title: {
            text: "",
          },
        };
      });
    },
    drawTagCloud() {
      let self = this;
      this.renderCloud = false;
      for (const [pidx, d] of this.data.entries()) {
        let seriesPositiveData = [];
        let seriesNegativeData = [];
        for (const [idx, p] of d.data.positive.entries()) {
          let obj = {};
          obj.name = p.word;
          obj.weight = p.frequency;
          obj.Display = p.display;
          obj.score = this.$options.filters.format(p.compound_score);
          seriesPositiveData.push(obj);
        }
        // console.log('seriespositivedata',seriesPositiveData);
        this.plotWordCloud(
          d.product_name,
          "positive",
          seriesPositiveData,
          10,
          22,
          " #065559"
        );
        for (const [idx, p] of d.data.negative.entries()) {
          let obj = {};
          obj.name = p.word;
          obj.weight = p.frequency;
          obj.Display = p.display;
          obj.score = this.$options.filters.format(p.compound_score);
          seriesNegativeData.push(obj);
        }
        this.plotWordCloud(
          d.product_name,
          "negative",
          seriesNegativeData,
          4,
          8,
          "#FD5542"
        );
        this.$nextTick(function () {
          this.renderCloud = true;
        });
      }
    },

    processTable() {
      let self = this;
      let renderChart = true;
      for (let [idx, d] of this.tableData.entries()) {
        self.tableData[d.product_name] = d.data;
        console.log;
        for (let [y, td] of d.data.entries()) {
          if (idx == this.tableData.length - 1 && y == d.data.length - 1) {
            renderChart = true;
          }
          this.drawgauge(
            renderChart,
            td.positive_score,
            td.negative_score,
            d.product_name,
            td.word
          );
        }
      }
      //
    },
    getData() {
      let self = this;
      this.modalLoader = true;
      this.loader = true;
      this.renderChart = false;
      this.data = [];
      this.defaultWords = {};
      this.date.from = moment(this.date.from).format("YYYY-MM-DD");
      this.date.to = moment(this.date.to).format("YYYY-MM-DD");
      let url =
        "/api/reviews/sentiment?client=" +
        self.customClient +
        "&channel=" +
        this.channelSelector +
        "&products=" +
        this.selectedProducts;
      if (this.date.startDate)
        url += "&start_date=" + this.date.startDate + "&end_date=" + this.date.endDate;
      this.$http.get(url).then(
        (response) => {
          this.data = response.body.data;
          this.tableData = response.body.table;
          this.loader = false;
          this.modalLoader = false;
          if (this.data) {
            this.drawTagCloud();
            this.processTable();
          }
        },
        (err) => {
          this.loader = false;
          this.modalLoader = false;
        }
      );
    },
  },
};
</script>

<style scoped>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.card_vivo {
  background-color: #0072ba !important;
  border: 1px solid #0072ba !important;
}

.card_realme {
  background-color: #f3b821 !important;
  border: 1px solid #f3b821 !important;
}

.card_redmi {
  background-color: #f56628 !important;
  border: 1px solid #f56628 !important;
}

.wordCloud {
  padding: 0;
  background: #f9f9f9;
  height: 150px !important;
}

.badge {
  padding: 5px;
  font-size: 13px;
}

.redbg {
  color: red;
  cursor: pointer;
}

.greenbg {
  color: green;
  cursor: pointer;
}

.highlight_primary {
  box-shadow: 0 0 0 0.2rem rgba(65, 181, 222, 0.5);
}

.highlight_success {
  box-shadow: 0 0 0 0.2rem rgba(104, 199, 137, 0.5);
}

.highlight_danger {
  box-shadow: 0 0 0 0.2rem rgba(249, 130, 129, 0.5);
}

.customselect {
  height: 34px;
  border-radius: 0;
  background: white;
  border: 1px solid silver;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
}

.highcharts-figure .chart-container {
  width: 300px;
  height: 200px;
  float: left;
}

.datebox {
  width: 11% !important;
}

/* revamp */
#SentimentCat {
  font-family: "Poppins", sans-serif !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.custom_dropdown {
  text-transform: uppercase;
  -youbkit-touch-callout: none;
  /* iOS Safari */
  -youbkit-user-select: none;
  /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE 10+ and Edge */
  user-select: none;
}

.datebox {
  width: 14% !important;
}

.custom_dropdown_wrap {
  cursor: pointer;
  display: flex;
  border: 1px solid silver;
  background: white;
  justify-content: space-between;
  padding: 7px;
  height: 30px;
}

.custom_dropdown_title {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* select  */
select {
  font-family: "Poppins", sans-serif;
}

.customSelect:focus {
  background: var(--base_color-5) !important;
  color: var(--primary_brand-60) !important;
  border: 1px solid var(--primary_brand-60) !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: 600 !important;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}

.wrapitem {
  display: flex !important;
  flex-direction: row;
  width: 100% !important;
  align-items: center;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
}

@media screen and (min-width: 1350px) {
  button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    font-weight: bold;
    font-size: 13px;
  }
}

/* @media screen and (min-width : 1500px) {
  button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 13px;
}
} */

/* @media screen and (min-width : 2000px) {
  button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 13px;
}
} */

button.success {
  background: var(--green);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
}

button.danger {
  background: var(--red);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.positive-head {
  padding: 15px;
  background: var(--primary_client-20);
  color: var(--primary_brand);
  margin-top: -5px !important;
  border-radius: 0.5rem;
  font-weight: 600;
}

.negative-head {
  padding: 15px;
  background: var(--red-20);
  color: var(--red);
  margin-top: -5px !important;
  border-radius: 0.5rem;
  font-weight: 600;
}

.separated-card:not(:last-child) {
  margin-right: 14px;
}

table {
  --border: 1px solid var(--base_color-20);
  border-radius: 10px;
  border-spacing: 0;
  border-collapse: separate;
  border: var(--border);
  overflow: hidden;
}

table th:not(:last-child),
table td:not(:last-child) {
  border-right: var(--border) !important;
}

table>thead>tr:not(:last-child)>th,
table>thead>tr:not(:last-child)>td,
table>tbody>tr:not(:last-child)>th,
table>tbody>tr:not(:last-child)>td,
table>tfoot>tr:not(:last-child)>th,
table>tfoot>tr:not(:last-child)>td,
table>tr:not(:last-child)>td,
table>tr:not(:last-child)>th,
table>thead:not(:last-child),
table>tbody:not(:last-child),
table>tfoot:not(:last-child) {
  border-bottom: var(--border) !important;
}

table th {
  background: var(--background);
  padding: 0.6rem !important;
  font-size: 14px !important;
  font-family: "Poppins", sans-serif !important;
}

table td {
  padding: 4px !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

.modalSelect {
  margin-bottom: 6px !important;
}

.eachProduct:hover {
  background: var(--base_color-20);
}

.productScroll {
  padding-top: 0px;
  cursor: pointer;
  height: 300px;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--base_color-10);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.borderBetween {
  border-bottom: 0.13rem solid #e1e1e1 !important;
  margin: 10px 0px 20px !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show>.btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}

.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}

.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}

.datePickerBadge {
  margin-left: 6px;
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}

.productScroll {
  padding-top: 0px;
  cursor: pointer;
  height: 300px;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--base_color-10);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.each-review {
  padding: 8px !important;
  background: none !important;
  margin-bottom: 3px !important;
  border-radius: 10px !important;
  margin-right: 2px !important;
  font-family: "Heebo", sans-serif !important;
}

.each-review:not(:first-child) {
  padding-top: 2px !important;
}

.usericon {
  background: var(--primary_brand-80);
  border-radius: 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.2rem;
}

.usericon img {
  filter: brightness(0) saturate(100%) invert(97%) sepia(3%) saturate(6%) hue-rotate(183deg) brightness(116%) contrast(100%);
  height: 15px;
}

.username {
  font-family: "Heebo", sans-serif;
  font-size: 15px;
  letter-spacing: 0.6px;
  color: var(--primary_brand);
  font-weight: 600;
  text-transform: capitalize;
}

.usertimestamp {
  font-family: "Heebo", sans-serif;
  font-size: 12px;
  letter-spacing: 0.6px;
  color: var(--base_color-60);
  font-weight: 600;
  margin-left: 12px;
  padding-top: 4px;
}

.helpful {
  float: right;
  display: inline-block;
  font-family: "Heebo", sans-serif;
  font-size: 12px;
  letter-spacing: 0.6px;
  color: var(--base_color-60);
  font-weight: 600;
  text-transform: capitalize;
  padding: 4px;
}

.usertext {
  display: inline-block;
  width: 100%;
  font-family: "Heebo", sans-serif;
  font-size: 14px !important;
}
</style>
<style lang="scss">
// .modal-title {
// 	font-weight: 400 !important;
// 	font-family: "poppins" !important;
// 	border-bottom: 1px solid #D5D5D5 !important;
// 	padding-bottom: 15px;

// 	/* extra */
// 	color: #5E5E5E !important;
// 	font-size: 16px;
// }

// .modal-header {
//   background: var(--primary_brand-20) !important;
//   color: var(--base_color);
//   border: none;
//   display: flex !important;
//   justify-content: start !important;
//   padding-bottom: 1rem !important;
//   font-family: "poppins";
// }

// .modal-header .close {
//   color: black;
//   text-shadow: none;
//   position: absolute;
//   top: -2px;
//   right: -6px;
//   font-size: 30px;
//   background: var(--primary_brand-10);
//   opacity: inherit;
//   padding: 5px 10px;
//   border-radius: 25px;
// }
</style>
